import * as React from 'react'
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import './CourseList.css'
import CourseListState from './CourseListState'
import { ClassConfig } from '../../../configs/stream-entities'

class CourseListProps {
    public isMultiple: boolean = false;
    public defaultValue: string = '';
    public onItemSelected: (doc: ClassConfig) => void
}

class CourseList extends React.Component<CourseListProps, CourseListState> {
    private classTypeIdList: string[] = [];
    private classTypeList: ClassConfig[] = [];
    private getCourseListTask: firebase.Unsubscribe;

    constructor(props: CourseListProps) {
        super(props);
        const newState = new CourseListState();
        newState.defaultValue = this.props.defaultValue;
        this.state = newState;
        this.onItemSelected = this.onItemSelected.bind(this);
    }

    public componentWillMount() {
        const dayIndex = new Date().getDay() +1 // because the rest of the system count sunday as 1 and not 0
        this.getCourseListTask = firebase.firestore().collection('config').doc("CoursesConfig").collection('courses').onSnapshot(snapshot => {
            snapshot.docChanges().forEach(query => {
                const newClass = new ClassConfig();
                newClass.titleLabel = query.doc.data().titleLabel;
                newClass.descriptionLabel = query.doc.data().descriptionLabel;
                newClass.backgroundImgURL = query.doc.data().backgroundImgURL;
                newClass.timeOfTheDay = query.doc.data().timeOfTheDay;
                newClass.teacherDayMapping = query.doc.data().teacherDayMapping;
                newClass.id = query.doc.id;
                newClass.description = query.doc.data().description;

                // get teacher id
                for (const mapping of newClass.teacherDayMapping) {
                    if (mapping.dayIndex === dayIndex) {
                        newClass.teacherId = mapping.teacherId;
                        newClass.description = mapping.customDescription ? mapping.customDescription : newClass.description;
                        break;
                    }
                }

                if (this.classTypeIdList.indexOf(query.doc.id) > -1) {
                    const index = this.classTypeIdList.indexOf(query.doc.id)
                    this.state.types[index] = this.getClassIdentifier(newClass.titleLabel)
                } else {
                    this.classTypeIdList.push(newClass.id)
                    this.classTypeList.push(newClass)
                    this.state.types.push(this.getClassIdentifier(newClass.titleLabel))
                }
                this.setState(this.state)
            })
        })
    }

    public componentWillUnmount() {
        this.getCourseListTask()
    }

    public render() {
        return (<select className="CourseList" onChange={this.onItemSelected} multiple={this.props.isMultiple} value={this.props.isMultiple ? [this.getSelectDefaultValue()] : this.getSelectDefaultValue()}>
            <option value="-1">Select a Class</option>
            {this.state.types.map((q, i) =>
                <option key={i} value={i}>{q}</option>
            )}
        </select>)
    }

    private getSelectDefaultValue(): string {
        for (let i = 0; i < this.classTypeList.length; i++) {
            if (this.classTypeList[i].id === this.state.defaultValue) {
                return String(i)
            }
        }
        return '-1'
    }

    private getClassIdentifier(titleLabel: string): string {
        const match = titleLabel.match('session_(.+)_[title|description|background]')
        if (match !== null && match.length > 1) {
            return match[1].replace(/_/g, ' ')
        }
        return titleLabel
    }

    private onItemSelected(event: React.ChangeEvent<HTMLSelectElement>) {
        const index = Number(event.currentTarget.value);
        if (index > -1) {
            const doc = this.classTypeList[index];
            this.props.onItemSelected(doc);
            this.setState({ defaultValue: doc.id });
        }
    }

}

export default CourseList


// WEBPACK FOOTER //
// ./src/components/schedule/course-list/CourseList.tsx